import * as Yup from 'yup';
import i18next from '../i18n';

export const emailLoginValidationSchema = Yup.object({
  email: Yup.string()
    .max(50, i18next.t('validationSchema.general.emailOrUsernameMaxLength'))
    .required(i18next.t('validationSchema.general.emailOrUsernameRequired')),
});
